import * as React from 'react'
import styles from './footer.module.scss'
import { Link } from 'react-router-dom'
import logo from '../../../../assets/img/logo/vision.jpg'

const Footer: React.FC = () => {
  return (
    <footer className={styles.footer}>
      <div className={styles.top}>
        <div className={styles.brand}>
          <img
            src={logo}
            alt='Vision International'
            className={styles.logo}
          />
          <p className={styles.tagline}>Freight Without Limits.</p>
        </div>

        <div className={styles.col}>
          <h4>Navigation</h4>
          <ul>
            <li>
              <Link to='/'>Home</Link>
            </li>
            <li>
              <Link to='/services'>Services</Link>
            </li>
            <li>
              <Link to='/about-us'>About Us</Link>
            </li>
            <li>
              <Link to='/contact-us'>Contact</Link>
            </li>
          </ul>
        </div>

        <div className={styles.col}>
          <h4>Services</h4>
          <ul>
            <li>Full Truckload (FTL)</li>
            <li>Less-Than-Truckload (LTL)</li>
            <li>Expedited Freight</li>
            <li>Refrigerated Transport</li>
            <li>Specialized Cargo</li>
            <li>Specialized Cargo</li>
          </ul>
        </div>

        <div className={styles.col}>
          <h4>Contact</h4>
          <ul>
            <li>1005 N Commons</li>
            <li>Aurora, IL 60504</li>
            <li>
              <a href='tel:+16305042688'>+1 (630) 504-2688</a>
            </li>
            <li>
              <a href='mailto:dispatch@vi4u.net'>dispatch@vi4u.net</a>
            </li>
            <li className={styles.dispatch}>Dispatch: 24/7</li>
          </ul>
        </div>
      </div>

      <div className={styles.bottom}>
        <span>DOT # 1312675 &nbsp;|&nbsp; MC# 550806</span>
        <span>
          &copy; {new Date().getFullYear()} Vision International LLC. All rights reserved.
        </span>
      </div>

      <div className={styles.poweredBy}>
        Powered by{' '}
        <a href='https://onitsoft.com/' target='_blank' rel='noopener noreferrer'>
          Onitsoft
        </a>
      </div>
    </footer>
  )
}

export default Footer
